import { v4 as uuidv4 } from 'uuid';

export function Submenu(props, childrenComponents = [], blocks = []) {
	return {
		componentName: 'Submenu',
		componentId: uuidv4(),
		props,
		childrenComponents,
		blocks,
	};
}
